import { render, staticRenderFns } from "./vsSpacer.vue?vue&type=template&id=44914ac6&"
import script from "./vsSpacer.vue?vue&type=script&lang=js&"
export * from "./vsSpacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsSpacer.vue"
export default component.exports